import { client } from './client';

export const companyApi = {
  getCompanyListView: () => client.get('get_company_list_view'),
  deleteCompany: (params) => client.get('delete_company', { params }),
  getCompanyList: () => client.get('get_company_list'),
  getCompanyNameList: () => client.get('get_company_name_list'),
  getCompanyInfo: (company_id) => client.get('get_company_info', { params: { company_id } }),
  setCompanyContractStatus: (params) => client.get('set_company_contract_status', { params }),
  editCompanyInfo: (params) => client.get('edit_company_info', { params }),
  addCompanyWithExistUser: (params) => client.get('add_company_with_exist_user', { params }),
  addCompanyWithNewUser: (params) => client.get('add_company_with_new_user', { params }),
  addPlace: (params) => client.get('add_place', { params }),
  getLocationsList: () => client.get('get_locations_list'),
  getLocationsByCompany: (company_name) => client.get('get_locations_by_company', { params: { company_name } }),
  editPlace: (params) => client.get('edit_place', { params }),
  deletePlace: (location_id) => client.get('delete_place', { params: { location_id } }),
  setMainOffice: (params) => client.get('set_main_office', { params }),
  getMainOffice: () => client.get('get_main_office'),
  getMissionRecipients: (company_id) => client.get('get_company_mission_recipients', { params: { company_id } }),
  getCompanyUsers: (company_id) => client.get('get_company_user_list', { params: { company_id } }),
  saveMissionRecipient: (params) => client.get('save_company_mission_recipient', { params }),
  deleteMissionRecipient: (params) => client.get('delete_company_mission_recipient', { params }),
};
